export const SPIRIT_TARGETS = {
  ADDED_SPIRITS: 'addedSpirits',
  ADD_SPIRIT: 'addSpirit',
  CURRENT_SPIRIT: 'currentSpirit'
};

export const SPIRIT_DEFAULT_STATE = {
  [SPIRIT_TARGETS.ADDED_SPIRITS]: [],
  [SPIRIT_TARGETS.ADD_SPIRIT]: null,
  [SPIRIT_TARGETS.CURRENT_WASH]: {}
};
